import Layout from '../components/layout/Layout';

const CookiesPage = () => {
  return (
    <Layout>
      <div className="py-10">
        <div className="container-custom">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Política de Cookies</h1>
          <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
            Última actualización: {new Date().toLocaleDateString()}
          </p>

          <div className="mt-6 space-y-6 text-gray-700 dark:text-gray-300 leading-relaxed">
            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white">1. Qué son las cookies</h2>
              <p className="mt-2 text-sm">
                Las cookies son pequeños archivos que un sitio puede guardar en tu navegador para recordar información (por ejemplo,
                preferencias o estado de sesión). Además de cookies, existen tecnologías similares como <strong>localStorage</strong>{' '}
                e <strong>IndexedDB</strong>.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white">2. Qué usa Illustra actualmente</h2>
              <p className="mt-2 text-sm">
                En la implementación actual, Illustra utiliza principalmente almacenamiento del navegador para funcionamiento:
              </p>
              <ul className="mt-3 space-y-2 text-sm">
                <li>
                  - <strong>Preferencias</strong>: por ejemplo, el modo oscuro se guarda en localStorage.
                </li>
                <li>
                  - <strong>Sesión</strong>: servicios de autenticación pueden persistir la sesión usando mecanismos del navegador
                  (por ejemplo, IndexedDB/localStorage).
                </li>
              </ul>
              <p className="mt-3 text-sm">
                No utilizamos cookies de marketing o publicidad por defecto. Si en el futuro se incorporan herramientas opcionales
                (por ejemplo, analítica), esta política podrá actualizarse.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white">3. Cómo podés gestionar cookies y almacenamiento</h2>
              <ul className="mt-3 space-y-2 text-sm">
                <li>- Podés borrar datos del sitio desde la configuración de tu navegador.</li>
                <li>- Podés bloquear cookies de terceros desde la configuración del navegador.</li>
                <li>
                  - Tené en cuenta que borrar datos puede cerrar sesión o reiniciar preferencias (por ejemplo, el tema).
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white">4. Contacto</h2>
              <p className="mt-2 text-sm">
                Si tenés preguntas sobre esta política, escribinos a{' '}
                <a href="mailto:illustra.contacto@gmail.com" className="text-indigo-600 dark:text-indigo-400 hover:underline">
                  illustra.contacto@gmail.com
                </a>
                .
              </p>
            </section>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default CookiesPage;

